import React from "react";
import { Form, Checkbox, Input, Row, Col } from "antd";

const Section5 = ({ formValues, setFormValues }) => {
  // Lists
  const ageGroups = [
    "11 and under",
    "12-18",
    "19-24",
    "25-34",
    "35-44",
    "45-54",
    "55-64",
    "65-74",
    "75+",
  ];

  const lifestyles = [
    "Arts & Culture",
    "Business & Economics",
    "Education",
    "Environmentally Conscious",
    "Fashion & Beauty",
    "Family-Oriented Audiences",
    "Foodies / Dining",
    "Health & Wellness",
    "LGBTQ+",
    "Outdoor Enthusiasts",
    "Politics & Advocacy",
    "Social Media Users",
    "Sports & Fitness",
    "Tech & Gaming",
    "Travel & Leisure",
    "Other (please specify)",
  ];

  const culturalGroups = [
    "Black / African American",
    "Hispanic / Latino",
    "Asian",
    "Native American / Alaska Native",
    "Pacific Islander / Hawaiian",
    "White (European descent)",
    "Other (please specify)",
  ];

  // helper to render checkboxes in a 2‑column grid
  const renderCheckboxGrid = (options, selectedValues, keyName) => (
    <Checkbox.Group
      value={selectedValues || []}
      onChange={(checked) => setFormValues({ ...formValues, [keyName]: checked })}
      style={{ width: "100%" }}
    >
      <Row gutter={[0, 8]}>
        {options.map((option) => (
          <Col span={12} key={option}>
            <Checkbox value={option}>{option}</Checkbox>
          </Col>
        ))}
      </Row>
    </Checkbox.Group>
  );

  return (
    <Form layout="vertical">

      {/* Age Groups */}
      <Form.Item label="21. What age groups do you typically help clients reach?">
        {renderCheckboxGrid(ageGroups, formValues.ageGroups, "ageGroups")}
      </Form.Item>

      {/* Lifestyles */}
      <Form.Item label="22. What lifestyles, interests, or communities do you have experience marketing to?">
        {renderCheckboxGrid(lifestyles, formValues.lifestyles, "lifestyles")}
      </Form.Item>

      {/* If “Other” is selected for lifestyles */}
      {formValues.lifestyles?.includes("Other (please specify)") && (
        <Form.Item label="Please specify other lifestyles, interests, or communities">
          <Input
            placeholder="Type any other audience types you market to"
            value={formValues.otherLifestyles || ""}
            onChange={(e) =>
              setFormValues({ ...formValues, otherLifestyles: e.target.value })
            }
          />
        </Form.Item>
      )}

      {/* Cultural Groups */}
      <Form.Item label="23. Do you specialize in ethnic or cultural marketing?">
        {renderCheckboxGrid(culturalGroups, formValues.culturalGroups, "culturalGroups")}
      </Form.Item>

      {/* If “Other” is selected for cultural groups */}
      {formValues.culturalGroups?.includes("Other (please specify)") && (
        <Form.Item label="Please specify other ethnic or cultural groups">
          <Input
            placeholder="Type any other cultural focus areas"
            value={formValues.otherCulturalGroups || ""}
            onChange={(e) =>
              setFormValues({
                ...formValues,
                otherCulturalGroups: e.target.value,
              })
            }
          />
        </Form.Item>
      )}
    </Form>
  );
};

export default Section5;
